import { useSelectedDealer, useSelectedLocation } from "components";
import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { ChecklistsDashboardQueryKeys } from "modules/ChecklistsDashboard/queryKeys";
import { ApiInstance } from "utils/Api";

import type { Checklist } from "models";

export const useUpdateChecklistMutation = () => {
  const { selectedDealer } = useSelectedDealer();
  const { selectedLocation } = useSelectedLocation();

  return useTypedMutation<Checklist, void>({
    mutationFn: async payload => {
      await ApiInstance.post("/checklists/update", payload, ENV.dealerBaseURL);
    },
    onSuccess: payload => {
      const tags = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.tags)?.filter(tag => payload.tag_ids?.includes(tag.id));
      const updatedFields = { ...payload, tags: tags ?? payload.tags };

      const defaultChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.defaultChecklists);
      const defaultChecklistIdx = defaultChecklists?.findIndex(dc => dc.id === payload.id) ?? -1;
      if (defaultChecklists && defaultChecklistIdx !== -1)
        typedQueryClient.setQueryData(
          ChecklistsDashboardQueryKeys.defaultChecklists,
          defaultChecklists.with(defaultChecklistIdx, { ...defaultChecklists[defaultChecklistIdx], ...updatedFields })
        );

      const dealerChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.dealerChecklists(selectedDealer?.id));
      const dealerChecklistIdx = dealerChecklists?.findIndex(dc => dc.id === payload.id) ?? -1;
      if (dealerChecklists && dealerChecklistIdx !== -1)
        typedQueryClient.setQueryData(
          ChecklistsDashboardQueryKeys.dealerChecklists(selectedDealer?.id),
          dealerChecklists.with(dealerChecklistIdx, { ...dealerChecklists[dealerChecklistIdx], ...updatedFields })
        );

      const locationChecklists = typedQueryClient.getQueryData(ChecklistsDashboardQueryKeys.locationChecklists(selectedLocation?.id));
      const locationChecklistIdx = locationChecklists?.findIndex(lc => lc.id === payload.id) ?? -1;
      if (!locationChecklists || locationChecklistIdx === -1) return;

      typedQueryClient.setQueryData(
        ChecklistsDashboardQueryKeys.locationChecklists(selectedLocation?.id),
        locationChecklists.with(locationChecklistIdx, { ...locationChecklists[locationChecklistIdx], ...updatedFields })
      );
    }
  });
};
